import FlexRow from "../../layout/Flexbox/FlexRow";
import { Color } from "../../../../utils/sys/Color";

type Props = {
    onColorSelected?: (color: Color) => void;
};

export default function InventoryItemIconEditorQuickColorsBar(
    props: Props
): JSX.Element {
    const colorOptions: Array<Color> = [
        "#646464",
        "#ffffff",
        "#0000ff",
        "#00ff00",
        "#ffff00",
        "#ff8700",
        "#a500ff",
    ];

    return (
        <FlexRow gap={4}>
            {colorOptions.map((color) => (
                <div
                    key={`color-option-${color.substring(1)}`}
                    className="quick-color-button"
                    style={{ backgroundColor: color }}
                    onClick={() => props.onColorSelected?.(color)}
                />
            ))}
        </FlexRow>
    );
}
